<footer class="main-footer">
  <div class="float-right d-none d-sm-block">
    <strong> {{ TextFooTer }} 
      <a [href]="UrlFooTer">{{ TextFooTerName }}</a>.</strong
    >
  </div>
  <strong>Cổng thông tin giảng viên. Full update 01 <a [routerLink]="['/admin/version-detail']">Version {{version}}</a></strong
  >
</footer>
